function PostJob() {
  return <h1>Post a Job</h1>;
}
export default PostJob;
